export function getDialogAccessibilityProps(
  titleId: string,
  hasTitle: boolean,
  ariaLabel?: string,
): {
  "aria-label": string | undefined;
  "aria-labelledby": string | undefined;
  "aria-modal": true;
  role: "dialog";
} {
  return {
    role: "dialog",
    "aria-modal": true,
    "aria-labelledby": hasTitle ? titleId : undefined,
    "aria-label": hasTitle ? undefined : ariaLabel,
  };
}
